import CrudRepository from './CrudRepository'
export default class PressReleaseYearsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/news/web/years')
  }
}
